import { render, staticRenderFns } from "./ComplaintReview.vue?vue&type=template&id=01690a00&"
import script from "./ComplaintReview.vue?vue&type=script&lang=js&"
export * from "./ComplaintReview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports